// extracted by mini-css-extract-plugin
export var taxonomyTermsHeading = "Article-module--taxonomyTermsHeading--yV0BK";
export var taxonomyTermsList = "Article-module--taxonomyTermsList--eih+O";
export var taxonomyTermsListItem = "Article-module--taxonomyTermsListItem--FQutw";